/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
class PushNotificationsService extends __BaseService {
  static readonly PushNotificationRegisterDeviceTokenPath = '/push-notifications/register/{token}';
  static readonly PushNotificationUnregisterDeviceTokenPath = '/push-notifications/unregister/{token}';
  static readonly PushNotificationSetAccountStatusPath = '/push-notifications/status';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * register a device token with the current user
   *
   * *
   * @param token the device token to register
   */
  PushNotificationRegisterDeviceTokenResponse(token: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/push-notifications/register/${encodeURIComponent(String(token))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * register a device token with the current user
   *
   * *
   * @param token the device token to register
   */
  PushNotificationRegisterDeviceToken(token: string): __Observable<null> {
    return this.PushNotificationRegisterDeviceTokenResponse(token).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * unregister a device token from the current user
   *
   * *
   * @param token the device token to unregister
   */
  PushNotificationUnregisterDeviceTokenResponse(token: string): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/push-notifications/unregister/${encodeURIComponent(String(token))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * unregister a device token from the current user
   *
   * *
   * @param token the device token to unregister
   */
  PushNotificationUnregisterDeviceToken(token: string): __Observable<null> {
    return this.PushNotificationUnregisterDeviceTokenResponse(token).pipe(
      __map(_r => _r.body as null)
    );
  }

  /**
   * Enable or disable an account receiving firebase notifications
   *
   * *
   * @param enabled are we enabling or disabling push notifications
   */
  PushNotificationSetAccountStatusResponse(enabled: boolean): __Observable<__StrictHttpResponse<null>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (enabled != null) __params = __params.set('enabled', enabled.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/push-notifications/status`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<null>;
      })
    );
  }
  /**
   * Enable or disable an account receiving firebase notifications
   *
   * *
   * @param enabled are we enabling or disabling push notifications
   */
  PushNotificationSetAccountStatus(enabled: boolean): __Observable<null> {
    return this.PushNotificationSetAccountStatusResponse(enabled).pipe(
      __map(_r => _r.body as null)
    );
  }
}

module PushNotificationsService {
}

export { PushNotificationsService }
